module.exports = __webpack_public_path__ + "static/6-4b527e35431351fdd838034308ebae90.jpg";